export default {
    isDisplayOnly: (productVariant) => productVariant?.StockStatus === 'DisplayOnly',
};
